import { useBooking } from '../../context/BookingContext'
import { RiCalendarLine, RiTimeLine, RiUserLine, RiScissorsFill } from 'react-icons/ri'
import { format } from 'date-fns'

export default function BookingSummaryBar() {
  const { booking, total, subtotal, discount } = useBooking()

  const hasAnything = booking.services.length > 0

  return (
    <div className="bg-white rounded-3xl shadow-salon-sm border border-salon-cream-dark p-6 sticky top-24">
      <h3 className="font-display text-salon-dark text-xl font-bold mb-5">Booking Summary</h3>

      {!hasAnything ? (
        <div className="flex flex-col items-center py-10 text-salon-muted text-center">
          <RiScissorsFill className="text-4xl text-salon-cream-dark mb-3" />
          <p className="text-sm font-body">No services selected yet</p>
        </div>
      ) : (
        <div className="space-y-4">
          {/* Services */}
          {booking.services.length > 0 && (
            <div>
              <p className="text-xs font-semibold text-salon-muted uppercase tracking-wider mb-2 font-body">Services</p>
              {booking.services.map((s) => (
                <div key={s.id} className="flex justify-between items-center py-1.5 text-sm font-body">
                  <span className="text-salon-dark">{s.name}</span>
                  <span className="text-salon-secondary font-semibold">₹{parseFloat(s.price).toLocaleString()}</span>
                </div>
              ))}
            </div>
          )}

          {/* Staff */}
          {booking.staff && (
            <div className="flex items-center gap-2 py-2 border-t border-salon-cream-dark pt-3">
              <RiUserLine className="text-salon-primary text-base shrink-0" />
              <span className="text-sm font-body text-salon-dark">{booking.staff.name}</span>
            </div>
          )}

          {/* Date/Time */}
          {booking.date && (
            <div className="flex items-center gap-2 text-sm font-body text-salon-dark border-t border-salon-cream-dark pt-3">
              <RiCalendarLine className="text-salon-primary shrink-0" />
              <span>{format(booking.date, 'EEE, dd MMM yyyy')}</span>
            </div>
          )}
          {booking.timeSlot && (
            <div className="flex items-center gap-2 text-sm font-body text-salon-dark">
              <RiTimeLine className="text-salon-primary shrink-0" />
              <span>{booking.timeSlot}</span>
            </div>
          )}

          {/* Pricing */}
          <div className="border-t border-salon-cream-dark pt-4 space-y-2">
            <div className="flex justify-between text-sm font-body">
              <span className="text-salon-muted">Subtotal</span>
              <span className="text-salon-dark">₹{subtotal.toLocaleString()}</span>
            </div>
            {discount > 0 && (
              <div className="flex justify-between text-sm font-body text-green-600">
                <span>Discount</span>
                <span>– ₹{discount.toLocaleString()}</span>
              </div>
            )}
            <div className="flex justify-between font-bold font-body pt-1 border-t border-salon-cream-dark">
              <span className="text-salon-dark">Total</span>
              <span className="text-salon-primary text-lg">₹{total.toLocaleString()}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
